
<spinner *ngIf="loading"></spinner>

<h5 class="mb-5">Create Therapeutic Schedule &gt;</h5>

<div class="row">
    <div class="col-4">
        <label class="form-label">Eating Disorder</label>
    </div>
    <div class="col-4">
        <label class="form-label">Age</label>
    </div>
    <div class="col">

    </div>
</div>
<div class="row mb-3">
    <div class="col-4">
        <select disabled class="form-select" aria-label="Default select example">
            <option selected value="1">Anorexia</option>
        </select>
    </div>
    <div class="col-4">
        <select disabled class="form-select" aria-label="Default select example">
            <option selected value="1">11 - 18</option>
        </select>
    </div>
    <div class="col">
        <button class="d-none btn btn-primary btn-lg">CREATE PROGRAMME </button>
    </div>
</div>


<div class="d-flex flex-wrap justify-content-between align-items-start gap-4">
    @for (category of categories; track category) {
        <div class="gray-box">
            <h5>{{category.title}}</h5>
            <div class="module-list" id="category-list-{{category.id}}"
                 [ngStyle]="{'grid-template-columns': category.modules.length > splitColumnsLimit? '1fr 1fr' : ''}"
                 cdkDropList
                 [cdkDropListData]="category.modules"
                 cdkDropListSortingDisabled="true"
                 [cdkDropListConnectedTo]="[earlyStageList, midStageList, lateStageList]"
                 (cdkDropListExited)="exitedCategory($event)"
                 (cdkDropListEntered)="enteredCategory($event)"
            >
                @for (item of category.modules; track item) {
                    <div class="module" [class.disabled]="isDisabled(item)" cdkDrag (cdkDragStarted)="dragStarted($event)" (cdkDragEnded)="dragEnded($event)" [cdkDragData]="item">
                        {{item.title}}  <span class="icon">
                            <a (click)="showModal(item.id)"><i style="font-size:16px" class="bi bi-info-circle"></i></a>
                        </span>
                        <div *cdkDragPlaceholder>
                            <div class="module disabled" *ngIf="!draggingOutsideSourceList">{{item.title}} <span class="icon"></span></div>
                            <div class="stage-card dashed" *ngIf="draggingOutsideSourceList"></div>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</div>

<h5 class="mt-4">Early stage</h5>
<div class="stage-container" id="early-stage-list"
     cdkDropList
     cdkDropListOrientation="horizontal"
     #earlyStageList="cdkDropList"
     [cdkDropListData]="earlyStageItems"
     (cdkDropListDropped)="dropped($event)"
     (cdkDropListEntered)="enteredStage($event)"
     (cdkDropListExited)="exitedStage($event)"
>
    @for (item of earlyStageItems; track item) {
        <div class="stage-card" cdkDrag>{{item.title}}
            <div class="icons">
                <a (click)="showModal(item.id)"><i class="bi bi-info-circle"></i></a>
                <i class="bi bi-x"></i>
            </div>
            <div *cdkDragPlaceholder>
                <div class="stage-card dashed"></div>
            </div>
            <div *cdkDragPreview>qwerqwer</div>
        </div>
    }
    <div class="stage-card dashed"></div>
</div>

<h5 class="mt-4">Mid stage</h5>
<div class="stage-container" id="mid-stage-list"
     cdkDropList
     cdkDropListOrientation="horizontal"
     #midStageList="cdkDropList"
     [cdkDropListData]="midStageItems"
     (cdkDropListDropped)="dropped($event)"
     (cdkDropListEntered)="enteredStage($event)"
     (cdkDropListExited)="exitedStage($event)"
>
    @for (item of midStageItems; track item) {
        <div class="stage-card" cdkDrag>{{item.title}}
            <div class="icons">
                <a (click)="showModal(item.id)"><i class="bi bi-info-circle"></i></a>
                <i class="bi bi-x"></i>
            </div>
            <div *cdkDragPlaceholder>
                <div class="stage-card dashed"></div>
            </div>
            <div *cdkDragPreview>qwerqwer</div>
        </div>
    }
    <div class="stage-card dashed"></div>
</div>

<h5 class="mt-4">Late stage</h5>
<div class="stage-container" id="late-stage-list"
     cdkDropList
     cdkDropListOrientation="horizontal"
     #lateStageList="cdkDropList"
     [cdkDropListData]="lateStageItems"
     (cdkDropListDropped)="dropped($event)"
     (cdkDropListEntered)="enteredStage($event)"
     (cdkDropListExited)="exitedStage($event)"
>
    @for (item of lateStageItems; track item) {
        <div class="stage-card" cdkDrag>{{item.title}}
            <div class="icons">
                <a (click)="showModal(item.id)"><i class="bi bi-info-circle"></i></a>
                <i class="bi bi-x"></i>
            </div>
            <div *cdkDragPlaceholder>
                <div class="stage-card dashed"></div>
            </div>
            <div *cdkDragPreview>qwerqwer</div>
        </div>
    }
    <div class="stage-card dashed"></div>
</div>

